import { Box, Chip, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import Button from 'components/Common/Button';
import { useForm } from 'react-hook-form';
import { AgentCloneRequest } from 'apis/business/agent/types';
import { useCloneAgent, useGetIndustries } from 'apis/business/agent/hook';
import { IndustriesResponse } from 'apis/business/agent/types';
import AgentTemplateGrid from './AgentTemplateGrid';

export default function SelectTemplate() {
  const theme = useTheme();
  const { mutateAsync: cloneAgent, isPending } = useCloneAgent();
  const { data: industries } = useGetIndustries();

  const [selectedIndustry, setSelectedIndustry] = useState<number | string>('');
  const [selectedAgent, setSelectedAgent] = useState<number | null>(null);

  const { handleSubmit } = useForm<AgentCloneRequest>();

  const handleCloneAgent = async () => {
    if (selectedAgent) {
      await cloneAgent({ agent_template_id: selectedAgent });
      localStorage.setItem('configuringAgent', 'withoutWebUrl');
    }
  };

  return (
    <Box component='form' bgcolor='white' p={3} borderRadius={2}>
      <Typography variant='h3' mb={0.5} fontSize={16} fontWeight={600}>
        Choose a Template
      </Typography>

      {/* Industry Chips */}
      <Box display='flex' gap={1} my={2} pb={2} overflow='auto'>
        {[{ key: '', label: 'All' }, ...(industries || [])]?.map((industry: IndustriesResponse) => (
          <Chip
            key={industry.key}
            label={industry.label}
            size='small'
            onClick={() => setSelectedIndustry(industry.key)}
            sx={{
              border: 1,
              paddingX: 1,
              paddingY: 2,
              fontSize: '14px',
              borderRadius: '15px',
              cursor: 'pointer',
              color: selectedIndustry !== industry.key ? 'black' : '#ECECEC',
              borderColor: selectedIndustry === industry.key ? theme.palette.primary.main : '#ECECEC',
              backgroundColor: selectedIndustry === industry.key ? theme.palette.primary.main : '#ECECEC',
              '&:hover': {
                backgroundColor: selectedIndustry === industry.key ? theme.palette.primary.main : '#ECECEC',
                borderColor: selectedIndustry === industry.key ? theme.palette.primary.main : '#ECECEC'
              }
            }}
          />
        ))}
      </Box>

      {/* Agent Template Grid */}
      <AgentTemplateGrid
        selectedIndustry={selectedIndustry}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
      />

      {/* Action Button */}
      <Box mt={3} display='flex' gap={1} justifyContent='end'>
        {selectedAgent && (
          <Button
            type='submit'
            variant='contained'
            color='primary'
            isPending={isPending}
            onClick={handleSubmit(handleCloneAgent)}
          >
            Continue
          </Button>
        )}
      </Box>
    </Box>
  );
}
